export const getSearchGeometryGeoJson = state => state.search.geometry;
